import React from 'react'
import UnauthorizedCard from 'src/components/UnauthorizedCard'
import { RouteLoader } from 'src/components/Loader'

export default function Unauthorized() {
    // keep this outside of the main routes so we don't loop indefinitely
    // when the user is unauthorized
    return (
        <>
            <React.Suspense fallback={<RouteLoader />}>
                <div className={'error-page'}>
                    <UnauthorizedCard globalAuth={true} />
                </div>
            </React.Suspense>
        </>
    )
}
